import { AfterViewInit, Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { KontoInsertPanel } from '@skylab-shared/types';
import { InsertUserPanelListComponent } from './insert-user-panel-list.component';
import { InsertUserPanelService } from './insert-user-panel.service';

@Component({
    selector: 'skl-insert-user-panel',
    templateUrl: 'insert-user-panel.component.html'
})
export class InsertUserPanelComponent implements AfterViewInit {

    @ViewChild(TemplateRef) private mainContent!: TemplateRef<any>;

    private texts!: KontoInsertPanel.TextsOpts;

    public constructor(
        @Inject(L10n) private readonly l10n: L10nBase,
        private readonly insertUserPanelService: InsertUserPanelService,
    ) {
        this.texts = {
            servicesFilterPlaceholder: this.l10n._T('insert-panel.services-filter-placeholder'),
            accountKI: this.l10n._T('insert-panel.account-KI'),
            logout: this.l10n._T('insert-panel.logout'),
            view: this.l10n._T('insert-panel.theme-switcher.appearance'),
            light: this.l10n._T('insert-panel.theme-switcher.themes.light'),
            dark: this.l10n._T('insert-panel.theme-switcher.themes.dark'),
            system: this.l10n._T('insert-panel.theme-switcher.themes.system'),
            systemTheme: this.l10n._T('insert-panel.theme-switcher.label.system'),
            lightTheme: this.l10n._T('insert-panel.theme-switcher.label.light'),
            darkTheme: this.l10n._T('insert-panel.theme-switcher.label.dark'),
        };
    }

    public ngAfterViewInit(): void {
        this.insertUserPanelService.create({
            component: InsertUserPanelListComponent,
            componentProps: {
                content: this.mainContent
            },
            wrapperId: 'insert-user-panel',
            texts: this.texts,
        });
    }

}
